import React from 'react';
import { Map, GoogleApiWrapper, Marker } from 'google-maps-react';


export class Maps extends React.Component {
    constructor(props) {
        super(props);
    
        this.state = {
          location: [{lat: 47.49855629475769, lng: -122.14184416996333}]
        }
      }
    
      displayMarkers = () => {
        return this.state.location.map((location, index) => {
          return <Marker key={index} id={index} position={{
           lat: location.latitude,
           lng: location.longitude
         }}
         onClick={() => console.log("You clicked me!")} />
        })
      }

    render() {
        const mapStyles = {
            width: '45%',
            height: '45%'
          };
      return (
        <Map
          google={this.props.google}
          zoom={8}
          style={mapStyles}
          initialCenter={{ lat: 47.444, lng: -122.176}}
        >
          {this.displayMarkers()}
        </Map>
    );
    }
  }
  
  export default GoogleApiWrapper({
    apiKey: ''
  })(Maps);